module.exports = __webpack_public_path__ + "static/media/loylatyRedemption.c3cb3e63.png";